import { SendTestEmailForm } from '@/components/campaigns/simulations/SendTestEmailForm';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  width: 511px;
`;

type SendTestEmailDialogProps = {
  visible: boolean;
  onHide: () => void;
  campaignId: string;
  emailTemplateId: string;
  sendingProfileId: string;
  landingPageId: string;
};

export const SendTestEmailDialog: React.FC<SendTestEmailDialogProps> = ({
  visible,
  onHide,
  campaignId,
  emailTemplateId,
  sendingProfileId,
  landingPageId,
}) => {
  const { t } = useTranslation();

  return (
    <StyledDialog
      visible={visible}
      onHide={onHide}
      header={t('simulations.testEmail.title')}
      modal
      draggable={false}
      resizable={false}
      className="v2"
      pt={{ root: { dir: document.documentElement.dir || 'ltr' } }}
    >
      <SendTestEmailForm
        campaignId={campaignId}
        emailTemplateId={emailTemplateId}
        sendingProfileId={sendingProfileId}
        landingPageId={landingPageId}
        onSuccess={onHide}
        onCancel={onHide}
        showCancelButton
      />
    </StyledDialog>
  );
};
